/**
 * Der Werkzeugkatalog vom Server.
 *
 * Ein eigener, winziger Client statt eines Eintrags in einer der grossen API-Dateien: Er wird von
 * genau einem Panel gebraucht und hat genau eine Operation. Das Register des Servers ist die
 * einzige Wahrheit — hier steht keine Liste, nur der Weg zu ihr.
 */
import { configuration } from "../../Configuration";
import { authenticatedFetch } from "../../JWTAuthService";
import type { CatalogueTool } from "./agentStepConfig";

export const fetchToolCatalogue = async (locale = "de"): Promise<CatalogueTool[]> => {
  const response = await authenticatedFetch(
    `${configuration.serverUrl}/api/tools?locale=${encodeURIComponent(locale)}`,
    { method: "GET" },
  );
  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }
  const body = await response.json();
  return Array.isArray(body?.tools) ? body.tools : [];
};
